import { Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { NotificationService } from '../notification.service';
import {
    DataEnvironment,
    DEFAULT_ENV,
    isValidEnv,
    normalizeEnv,
} from './models/data-environment.model';

/**
 * Service to manage data environment (e.g., prod, staging, dev)
 */
@Injectable({ providedIn: 'root' })
export class DataEnvironmentService implements OnInit {
    private envSubject = new BehaviorSubject<DataEnvironment>(DEFAULT_ENV);
    env$ = this.envSubject.asObservable();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private notification: NotificationService
    ) {}

    ngOnInit(): void {}

    /**
     * Initialize environment from URL parameter
     * @param paramEnv Environment parameter from URL
     */
    initFromParam(paramEnv: string | null) {
        if (!isValidEnv(paramEnv)) {
            this.notification.warning(
                'Invalid environment',
                `"Environment not provided. Using default: "${DEFAULT_ENV}".`
            );
            this.changeEnv(normalizeEnv(paramEnv));
        } else {
            // ustaw aktualne środowisko
            this.setEnv(normalizeEnv(paramEnv));
        }
    }

    /**
     * Set environment without navigation
     * @param env Environment to set
     */
    setEnv(env: DataEnvironment) {
        this.envSubject.next(env);
    }

    /** Change environment with navigation */
    changeEnv(env: DataEnvironment, reload: boolean = false) {
        this.envSubject.next(env);
        this.navigateWithEnv(env).then(() => {
            if (reload) {
                // refresh browser
                window.location.reload();
            }
        });
    }

    private navigateWithEnv(
        env: DataEnvironment,
        extras: NavigationExtras = {}
    ): Promise<boolean> {
        return this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { env },
            queryParamsHandling: 'merge',
            ...extras,
        });
    }

    get current(): DataEnvironment {
        return this.envSubject.value;
    }
}
